/*******************************************************************************
 * Copyright (c) 2024-2026 Malond Limited. All rights reserved.
 * The source code is the property of Malond Limited.
 ******************************************************************************/

export type DesktopRuntime = "electron" | "tauri" | "web"

export const getDesktopRuntime = (): DesktopRuntime => {
  if (typeof window !== "undefined") {
    const win = window as unknown as {
      electronAuth?: { isElectron?: boolean; login?: unknown }
      electron?: { apiRequest?: unknown }
      __TAURI_INTERNALS__?: unknown
      __TAURI__?: unknown
      isTauri?: unknown
    }

    if (Boolean(win.electronAuth) || Boolean(win.electron?.apiRequest)) {
      return "electron"
    }

    if (
      "__TAURI_INTERNALS__" in win ||
      "__TAURI__" in win ||
      Boolean(win.isTauri)
    ) {
      return "tauri"
    }
  }

  return "web"
}

export const isDesktop = (): boolean => getDesktopRuntime() !== "web"
export const isElectron = (): boolean => getDesktopRuntime() === "electron"
export const isTauri = (): boolean => getDesktopRuntime() === "tauri"
